module.exports = __webpack_public_path__ + "static/media/iib.28efd486.png";